import PropTypes from 'prop-types';
import { Link, useMatch } from 'react-router-dom';

import { ACTIVE_STATE_CLASS_NAME } from 'consts';

const NavLink = (props) => {
  const { to } = props;
  const partialMatch = useMatch(`${to}/*`);

  return (
    <Link
      className={partialMatch ? ACTIVE_STATE_CLASS_NAME : null}
      {...props}
    />
  );
};

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
};

export default NavLink;
